<div *ngIf="visible" class="container-modal">
  <div class="box-message">
    <ng-lottie width="51px" height="59px" [options]="options"></ng-lottie>
    <span class="message">
      <p style="font-size: 16px; font-weight: 600">Tu plan venció</p>
      <p style="font-size: 14px; font-weight: 500">
        Tu cuenta ahora es gratuita. Suscríbete a un plan y recupera todos tus beneficios.
      </p>
    </span>
    <button class="close-button close-mobile" (click)="closeNotification()">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <div class="buttons">
    <button class="btn-plan" (click)="showPlansDialog = true">Ver planes</button>
    <button class="close-button close-desktop" (click)="closeNotification()">
      <i class="pi pi-times"></i>
    </button>
  </div>
</div>
<p-dialog
  header="Planes de suscripción"
  [modal]="true"
  [style]="{ width: '70rem' }"
  [(visible)]="showPlansDialog"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [resizable]="false"
>
  <globot-type-subscription-plans></globot-type-subscription-plans>
</p-dialog>
